import { StoredSection } from '@/entities/templates';

/** Build section sortable IDs from sections. Uses section.code as stable ID. */
export const getSectionIds = (sections: StoredSection[]): string[] =>
  sections.map((s, i) => s.code || `section-${i}`);
